import * as React from 'react';
import {
    Identifier,
    Datagrid,
    DateField,
    TextField,
    DatagridProps,
    FunctionField,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import commonRowStyle from '../common/commonRowStyle';


const useListStyles = makeStyles({
    headerRow: {
        borderLeftColor: 'transparent',
        borderLeftWidth: 5,
        borderLeftStyle: 'solid',
    },
    headerCell: {
        padding: '6px 8px 6px 8px',
    },
    rowCell: {
        padding: '6px 8px 6px 8px',
    },
    comment: {
        maxWidth: '18em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});

const LocationListDesktop = ({ selectedRow, ...props }) => {
    const classes = useListStyles();
    return (
        <Datagrid
            rowClick="show"
            //rowClick={(id) => `/${resource}/${id}/editOnSide`}
            // @ts-ignore
            rowStyle={commonRowStyle(selectedRow)}
            classes={{
                headerRow: classes.headerRow,
                headerCell: classes.headerCell,
                rowCell: classes.rowCell,
            }}
            optimized
            {...props}
        >
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="address" />
        </Datagrid>
    );
};

export default LocationListDesktop;